import React, { useContext, useState } from "react";
import { CodesToColorMapFunc } from "../../CodesToColorMap";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { CheckCircle, XCircle } from "../../components/common/IconsV2";
import {
	getDateOrdinal,
	getMonthAbbreviation,
} from "../../services/dateService";

export const SummaryChart = ({ code, data, def }) => {
	const columns = def.format.grid.columns ?? 4;
	const rows = def.format.grid.rows ?? 1;

	const initialDisplay = columns * rows;

	const months =
		def.format.maxDisplay < 0
			? data.months
			: data.months.slice(-def.format.maxDisplay);

	for (const m of months) {
		if (!m.date) {
			continue;
		}

		const dt = new Date(m.date);
		m.month = getMonthAbbreviation(dt.getMonth()).toUpperCase();
		m.year = dt.getFullYear();
		m.day = dt.getDate() + getDateOrdinal(dt.getDate());
		m.dayMonth = `${m.day} ${m.month}`;
	}

	while (months.length < initialDisplay) {
		months.push({ label: "" });
	}

	const { theme } = useContext(DiseaseGroupContext);

	const [codeTheme] = useState(CodesToColorMapFunc(code, theme));

	const createGridSquare = (month, index) => {
		const circleCls = def.format.showFullDate
			? "sm:w-8 sm:h-8"
			: "sm:w-10 sm:h-10";
		const paddingCls = def.format.showFullDate ? "pb-1 pt-1" : "pt-4";
		const check = (
			<div
				className={
					"flex flex-1 items-center justify-center pb-2 pt-0.5 sm:py-3"
				}
			>
				{month.value === true ? (
					<CheckCircle className={`w-6 h-6 ${circleCls} text-white`} />
				) : month.value === false ? (
					<XCircle className={`w-6 h-6 ${circleCls} text-gray-400`} />
				) : null}
			</div>
		);

		let bg = "bg-white";
		let color = "text-white";
		if (month.label) {
			if (month.value) {
				bg = codeTheme ? codeTheme.bg() : "bg-cyan-100";
				color = "text-white";
			} else {
				bg = "bg-gray-200";
				color = "text-gray-400";
			}
		}

		const ht = data.months.length <= 12 ? "h-24" : "h-24";
		const topLabel = def.format.showFullDate
			? <b>{month.dayMonth}</b> || ""
			: <b>{month.label}</b> || "";
		const bottomLabel = def.format.showFullDate
			? <b>{month.year}</b> || ""
			: "";

		return (
			<div
				key={`month${index}`}
				className={`col ${bg} text-center text-black rounded-sm ${ht}`}
			>
				<div className={"square flex justify-center"}>
					<div className={`flex flex-col ${paddingCls} text-xs ${color} ${ht}`}>
						{topLabel}
						{check}
						{bottomLabel}
					</div>
				</div>
			</div>
		);
	};

	return (
		<div
			className={`h-full grid grid-cols-${columns} gap-2.5 sm:gap-3 bg-white p-px text-xs sm:text-md font-medium max-w-panel sm:max-h-3/4`}
		>
			{months.map(createGridSquare)}
		</div>
	);
};
